import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import Button from 'flarum/common/components/Button';
import SplitDropdown from 'flarum/common/components/SplitDropdown';
import { data, getNativeData } from './util/share';
import { getNetworkButtons } from './util/networks';
export { default as extend } from './extend';
app.initializers.add('fof/share-social', () => {
  extend(DiscussionPage.prototype, 'sidebarItems', function (items) {
    const page = this;
    const discussion = page.discussion;
    if (!discussion) return;
    const networks = app.forum.attribute('fof-share-social.networks');
    const def = app.forum.attribute('fof-share-social.default');
    const isNativeShare = def === 'native';
    const canNativeShare = isNativeShare && navigator.canShare?.(getNativeData(data(discussion)));
    if (def && (!isNativeShare || canNativeShare)) {
      const list = getNetworkButtons(discussion);

      // Use default share button text for native sharing
      if (isNativeShare) {
        list.get('native').children = app.translator.trans('fof-share-social.forum.discussion.share_button');
      }
      if (list.isEmpty()) return;
      items.add('share-social', m(SplitDropdown, {
        icon: "fas fa-share-alt",
        buttonClassName: "Button--share",
        accessibleToggleLabel: app.translator.trans('fof-share-social.forum.discussion.share_dropdown_accessible_label'),
        lazyDraw: true
      }, list.toArray()));
    } else {
      items.add('share-social', m(Button, {
        class: "Button Button-icon Button--share",
        icon: "fas fa-share-alt",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/ShareModal', webpackMode: 'lazy-once' */ './components/ShareModal'), {
          networks,
          discussion
        })
      }, app.translator.trans('fof-share-social.forum.discussion.share_button')), -1);
    }
  });
});flarum.reg.addChunkModule('84', '122', 'fof-share-social', 'forum/components/ShareModal');